import React from 'react';
import { DocumentIcon } from '@/components/contextActions/icons';
import { HeaderIconButton } from '@/components/contextActions/common';
import { openCustomDocumentDrawer } from '@/modules/appContext';
import { useAppDispatch, useCurrentPatientIdParam } from '@/hooks';

export const CustomDocumentDrawerButton = () => {
  const dispatch = useAppDispatch();
  const patientId = useCurrentPatientIdParam();

  return (
    <HeaderIconButton
      icon={<DocumentIcon />}
      onClick={() => dispatch(openCustomDocumentDrawer({ patientId }))}
    />
  );
};
